import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const ConnectedAccounts = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="M10.4853 13H5C3.9 13 3 13.9 3 15V19H5V15H9.03031C9.27437 14.4049 9.63804 13.8472 10.1213 13.364L10.4853 13Z"
      fill="currentColor"
    />
    <path
      clipRule="evenodd"
      d="M10 11H8C6.9 11 6 10.1 6 9V5C6 3.9 6.9 3 8 3H10C11.1 3 12 3.9 12 5V9C12 10.1 11.1 11 10 11ZM10 5H8V9H10V5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      d="M15.0711 18.3137C14.29 19.0948 13.0237 19.0948 12.2426 18.3137C11.4616 17.5327 11.4616 16.2663 12.2426 15.4853L13.6569 14.0711L12.2426 12.6569L10.8284 14.0711C9.26633 15.6332 9.26633 18.1658 10.8284 19.7279C12.3905 21.29 14.9232 21.29 16.4853 19.7279L17.8995 18.3137L16.4853 16.8995L15.0711 18.3137Z"
      fill="currentColor"
    />
    <path
      d="M16.4853 11.2426C17.2663 10.4616 18.5327 10.4616 19.3137 11.2426C20.0948 12.0237 20.0948 13.29 19.3137 14.0711L17.8995 15.4853L19.3137 16.8995L20.7279 15.4853C22.29 13.9232 22.29 11.3905 20.7279 9.82843C19.1658 8.26633 16.6332 8.26633 15.0711 9.82843L13.6569 11.2426L15.0711 12.6569L16.4853 11.2426Z"
      fill="currentColor"
    />
    <path
      d="M12.9497 16.1924C12.5592 16.5829 12.5592 17.2161 12.9497 17.6066C13.3403 17.9971 13.9734 17.9971 14.364 17.6066L18.6066 13.364C18.9971 12.9734 18.9971 12.3403 18.6066 11.9497C18.2161 11.5592 17.5829 11.5592 17.1924 11.9497L12.9497 16.1924Z"
      fill="currentColor"
    />
  </Icon>
));

export default ConnectedAccounts;
